import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

function effectivePrice(product, variant) {
  if (variant) {
    if (variant.sale_price != null && variant.sale_price !== "") return Number(variant.sale_price);
    if (variant.price != null && variant.price !== "") return Number(variant.price);
  }
  if (product.sale_price != null && product.sale_price !== "") return Number(product.sale_price);
  return Number(product.price);
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("vgs_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("vgs_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, variant = null) => {
    const key = `${product.id}:${variant?.id || ""}`;
    const label = variant
      ? [variant.size, variant.color, variant.pack].filter((x) => x && x !== "Default").join(" / ")
      : "";
    setItems((prev) => {
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, qty: i.qty + 1 } : i));
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          variant_id: variant?.id || null,
          variant_label: label,
          name: product.name,
          price: effectivePrice(product, variant),
          image_url: variant?.image_url || product.image_url,
          unit: product.unit,
          qty: 1,
        },
      ];
    });
  };

  const setQty = (key, qty) => {
    if (qty <= 0) return removeItem(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, qty } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));

  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const total = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, setQty, removeItem, clear, count, total }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
